import { createAction } from 'redux-actions'
import log from 'sentry/log'
import { actionCreators as api } from 'reduxBits/api'

const prefix = 'Classified:'
export const REQUEST_AD = `${prefix} Send an async get-me-an-ad request to server.`
export const RECEIVE_AD = `${prefix} Update the state with the fetched ad data.`

const requestAd = createAction(REQUEST_AD)
const receiveAd = createAction(RECEIVE_AD)

const fetchAd = (id) => (dispatch) => {
  dispatch(requestAd())

  return dispatch(api.fetch(`search_bff/v2/content/${id}?include=store`)).then(
    (response) =>
      dispatch(
        receiveAd({
          ...response.data,
        }),
      ),
    (error) => {
      log.message(`fetch ad error ${error}`)
      dispatch(receiveAd(error))
    },
  )
}

export const actionCreators = {
  fetchAd,
  receiveAd,
}
